function ProgrammePickerModal({
  isOpen,
  onClose,
  isMobile,
  hoveredButton,
  setHoveredButton,
  programmeSearch,
  setProgrammeSearch,
  filteredProgrammes,
  openProgrammeDetails,
  chooseProgramme,
  modalOverlayStyle,
  modalContentStyle,
  closeButtonStyle,
  secondaryButtonStyle,
  appTheme
}) {
  if (!isOpen) return null;

  return (
    <div
      style={modalOverlayStyle}
      onClick={onClose}
    >
      <div
        style={{
          ...modalContentStyle,
          maxWidth: isMobile ? "94vw" : "720px",
          padding: isMobile ? "20px 16px 18px" : "24px 22px 22px"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "12px",
            marginBottom: "16px"
          }}
        >
          <div>
            <h2
              style={{
                margin: 0,
                fontSize: isMobile ? "22px" : "28px",
                fontWeight: "700",
                fontFamily: appTheme.fontHeading,
                color: appTheme.primaryText,
                lineHeight: 1.1
              }}
            >
              Pick a Programme
            </h2>

            <div
              style={{
                marginTop: "6px",
                fontSize: "14px",
                color: appTheme.secondaryText,
                lineHeight: 1.5
              }}
            >
              Choose a guided plan or keep building your own weeks manually.
            </div>
          </div>

          <button
            onMouseEnter={() => setHoveredButton("close-programme-picker")}
            onMouseLeave={() => setHoveredButton(null)}
            onClick={onClose}
            style={closeButtonStyle(hoveredButton, "close-programme-picker", appTheme)}
          >
            ×
          </button>
        </div>

        <div style={{ marginBottom: "16px" }}>
          <input
            value={programmeSearch}
            onChange={(e) => setProgrammeSearch(e.target.value)}
            placeholder="Search programmes..."
            style={{
              width: "100%",
              boxSizing: "border-box",
              padding: "14px 16px",
              borderRadius: "999px",
              background: appTheme.inputBackground,
              border: appTheme.cardBorder,
              outline: "none",
              fontSize: "14px",
              color: appTheme.primaryText
            }}
          />
        </div>

        <div
          style={{
            display: "grid",
            gap: "12px",
            maxHeight: isMobile ? "52vh" : "56vh",
            overflowY: "auto",
            paddingRight: "2px",
            WebkitOverflowScrolling: "touch",
            overscrollBehavior: "contain"
          }}
        >
          {filteredProgrammes.length > 0 ? (
            filteredProgrammes.map((programme) => (
              <div
                key={programme.id}
                style={{
                  padding: isMobile ? "14px" : "16px",
                  borderRadius: "20px",
                  background: appTheme.cardBackground,
                  border: appTheme.cardBorder,
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    gap: "12px",
                    marginBottom: "10px"
                  }}
                >
                  <div style={{ minWidth: 0 }}>
                    <div
                      style={{
                        fontSize: "18px",
                        fontWeight: "700",
                        fontFamily: appTheme.fontHeading,
                        color: appTheme.primaryText,
                        lineHeight: 1.2,
                        marginBottom: "6px"
                      }}
                    >
                      {programme.name}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        flexWrap: "wrap"
                      }}
                    >
                      <span
                        style={{
                          padding: "6px 10px",
                          borderRadius: "999px",
                          background: appTheme.accentLight,
                          color: appTheme.accentColor,
                          fontSize: "12px",
                          fontWeight: "700"
                        }}
                      >
                        {programme.duration}
                      </span>

                      <span
                        style={{
                          padding: "6px 10px",
                          borderRadius: "999px",
                          background: appTheme.pillBackground,
                          color: appTheme.secondaryText,
                          fontSize: "12px",
                          fontWeight: "700"
                        }}
                      >
                        {programme.focus}
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    fontSize: "14px",
                    color: appTheme.secondaryText,
                    lineHeight: 1.55,
                    marginBottom: "14px"
                  }}
                >
                  {programme.summary}
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    flexWrap: "wrap",
                    justifyContent: "flex-end"
                  }}
                >
                  <button
                    onMouseEnter={() =>
                      setHoveredButton(`programme-details-${programme.id}`)
                    }
                    onMouseLeave={() => setHoveredButton(null)}
                    onClick={() => openProgrammeDetails(programme)}
                    style={secondaryButtonStyle(appTheme, hoveredButton, `programme-details-${programme.id}`)}
                  >
                    Details
                  </button>

                  <button
                    onMouseEnter={() =>
                      setHoveredButton(`programme-choose-${programme.id}`)
                    }
                    onMouseLeave={() => setHoveredButton(null)}
                    onClick={() => chooseProgramme(programme)}
                    style={{
                      ...secondaryButtonStyle(appTheme, hoveredButton, `programme-choose-${programme.id}`),
                      background: appTheme.accentLight,
                      border: appTheme.accentBorder,
                      color: appTheme.accentColor
                    }}
                  >
                    Choose Programme
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div
              style={{
                padding: "18px",
                borderRadius: "18px",
                background: appTheme.softBackground,
                border: appTheme.cardBorder,
                color: appTheme.secondaryText
              }}
            >
              No programmes match your search.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProgrammePickerModal;